export default __webpack_public_path__ + "static/media/cancer3.49a46b01.jpg";